import { defineStore } from 'pinia';
import api from '../api/client.js';
import { useKeycloakStore } from './keycloak.js';

const topic = 'notifications/topic';
const notification = 'notifications/notification';

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    msgCltConnected: false,
    messageSocketClient: '',
    deviceToken: '',
    topic: '',
    topicList: '',
    notificationList: [],
    newNotifList: [],
  }),
  persist: true,

  actions: {
    msgConnectSocketed(msgCltConnected) {
      this.msgCltConnected = msgCltConnected;
    },

    msgConnectSocketClient(messageSocketClient) {
      this.messageSocketClient = messageSocketClient;
    },

    async registerDeviceToken(payload) {
      try {
        console.log('[Notification Store] Registering device token with payload:', payload);
        const { data } = await api.post(`${topic}/register/token`, payload, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        console.log('[Notification Store] Device token registration successful:', data);
        this.deviceToken = data;
        return data;
      } catch (err) {
        console.error('[Notification Store] Device token registration failed:', err.response?.data || err);
        throw err;
      }
    },

    async unregisterDeviceToken(payload) {
      try {
        console.log('[Notification Store] Unregistering device token:', payload);
        await api.delete(`${topic}/unregister/token`, {
          params: { token: payload },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        console.log('[Notification Store] Device token unregistered successfully');
      } catch (err) {
        console.error('[Notification Store] Device token unregistration failed:', err.response?.data || err);
        throw err;
      }
    },

    async createTopic(payload) {
      try {
        await api.post(`${topic}/create`, payload, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.topic = topic;
        await this.getMyTopicList();
      } catch (err) {
        console.log(err.response?.data || err);
      }
    },

    async deleteTopic(payload) {
      try {
        await api.delete(`${topic}/delete`, {
          params: { topicId: payload },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        await this.getMyTopicList();
      } catch (err) {
        console.log(err.response?.data || err);
      }
    },

    async subscribeToTopic(payload) {
      try {
        console.log('[Notification Store] Subscribing to topic:', payload);
        await api.post(`${topic}/subscribe`, payload, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        await this.getMyTopicList();
        console.log('[Notification Store] Topic subscription successful');
      } catch (err) {
        console.error('[Notification Store] Topic subscription failed:', err.response?.data || err);
        throw err;
      }
    },

    async getMyTopicList() {
      try {
        const { data } = await api.get(`${topic}/getAll`, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.topicList = data;
      } catch (err) {
        console.log(err.response?.data || err);
      }
    },

    async getNotificationList(payload) {
      try {
        const { data } = await api.get(`${notification}/getAll`, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          params: { limit: payload.limit, skip: payload.skip },
        });
        this.newNotifList = data;
        this.notificationList.push(...data);
      } catch (err) {
        console.log(err.response?.data || err);
      }
    },

    async deleteNotification(payload) {
      try {
        await api.put(
          `${notification}/delete`,
          null,
          {
            params: { notificationId: payload },
            headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          }
        );
        const index = this.notificationList.findIndex(
          (n) => n.id === payload
        );
        if (index > -1) {
          const updatedNotification = {
            ...this.notificationList[index],
            has_deleted: [...(this.notificationList[index].has_deleted || []), useKeycloakStore().subject],
          };
          this.notificationList.splice(index, 1, updatedNotification);
        }
      } catch (err) {
        console.log(err);
      }
    },

    async readNotification(payload) {
      try {
        await api.put(
          `${notification}/read`,
          null,
          {
            params: { notificationId: payload },
            headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          }
        );
        const index = this.notificationList.findIndex(
          (n) => n.id === payload
        );
        if (index > -1) {
          const updatedNotification = {
            ...this.notificationList[index],
            has_read: [...(this.notificationList[index].has_read || []), useKeycloakStore().subject],
          };
          this.notificationList.splice(index, 1, updatedNotification);
        }
      } catch (err) {
        console.log(err);
      }
    },

    addNewNotification(payload) {
      const index = this.notificationList.findIndex(
        (n) => n.id === payload.id
      );
      if (index !== -1) {
        const updatedNotification = {
          ...this.notificationList[index],
          ...payload,
        };
        this.notificationList.splice(index, 1, updatedNotification);
      } else {
        this.notificationList.push(payload);
      }
    },
  },
});
